import React from "react";
import "./Sections.scss";
import img1 from "../../assets/explore.png";

function Explore() {
  return (
    <div className="explore">
      <a
        className="section__end__link"
        href="https://robertocoin.com/en-us/collection/love-in-verona/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={img1} alt="" className="explore__img" />
      </a>
      <p className="explore__copy">
        Roberto Coin invites you to explore the Love in Verona collection at{" "}
        <a
          className="section__end__link"
          href="https://robertocoin.com/en-us/collection/love-in-verona/"
          target="_blank"
          rel="noreferrer"
        >
          robertocoin.com
        </a>
      </p>
    </div>
  );
}

export default Explore;
